import axios from "axios";
import router from "@/router";

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.withCredentials = true;

var baseDomain = "";
if (process.env.NODE_ENV === "production") {
  baseDomain = "https://api2.agrotec.pe";
} else {
  baseDomain = "https://localhost:3000";
}
const baseURL = `${baseDomain}/api/v1/`;

var axios_instance = axios.create({
  baseURL
});

axios_instance.interceptors.response.use(undefined, function (err) {
  return new Promise(function () {
    if (err.response.status === 401) {
      if (err.response.data.error != "not_authorized_credentials") {
        router.push({ name: "logout_path" });
      }else{
        throw err;
      }
    } else { throw err; }
  });
});

export { baseDomain };

export default axios_instance;
